import { useCallback } from 'react';
import { useSettingsStore, PlaybackEventEmitter, PlaybackEvent } from '@annunciate/core';
const PLAYBACK_SPEED_INTERVALS = {
    1: 1.25,
    1.25: 1.5,
    1.5: 2,
    2: 1,
};
const { setPlaybackSpeed } = useSettingsStore.getState();
export const usePlaybackSpeed = () => {
    const playbackSpeed = useSettingsStore(state => state.playbackSpeed);
    const nextPlaybackSpeed = useCallback(() => {
        const speed = PLAYBACK_SPEED_INTERVALS[playbackSpeed];
        setPlaybackSpeed(speed);
        PlaybackEventEmitter.emit(PlaybackEvent.SET_PLAYBACK_RATE, { rate: speed });
    }, [playbackSpeed]);
    const wrappedSetPlaybackSpeed = useCallback((newSpeed) => {
        setPlaybackSpeed(newSpeed);
        PlaybackEventEmitter.emit(PlaybackEvent.SET_PLAYBACK_RATE, { rate: newSpeed });
    }, []);
    return {
        playbackSpeed,
        setPlaybackSpeed: wrappedSetPlaybackSpeed,
        nextPlaybackSpeed,
    };
};
//# sourceMappingURL=usePlaybackSpeed.js.map